module.exports = __webpack_public_path__ + "img/crustaces.a155429e.svg";